/** Fehlertypen des API-Clients. */
export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

/** 401 — nicht angemeldet → Guard leitet auf den SSO-Login. */
export class UnauthorizedError extends ApiError {
  constructor(message = 'Nicht authentifiziert') {
    super(401, message);
    this.name = 'UnauthorizedError';
  }
}

/** 403 — angemeldet, aber NICHT in der ALLOWED_USERS-Liste (ADR-003 v2).
 *  KEIN Login-Redirect (sonst Endlosschleife) → klare „Kein Zugriff"-Meldung. */
export class ForbiddenError extends ApiError {
  constructor(message = 'Kein Zugriff') {
    super(403, message);
    this.name = 'ForbiddenError';
  }
}
